<button
  [class]="buttonClass"
  [id]="id"
  theme="landing-page-large"
  [matTooltip]="tooltip"
  matTooltipShowDelay="500"
  [disabled]="disabled"
  (click)="onClick()"
>

  <mat-icon
    [class]="twoButtons ? 'drafts-icon-small' : 'drafts-icon'"
    fontSet="material-icons-outlined"
    [ngClass]="{ invalid: !validConfig }">
    {{ icon }}
  </mat-icon>

  <mat-icon fontSet="material-icons-outlined" class="background-icon">{{ icon }}</mat-icon>

  @if (!validConfig) {
    <mat-icon
      [matTooltip]="invalidTooltip"
      matTooltipShowDelay="500"
      class="warning-icon"
      [fontIcon]="renderMode === 'web-app' ? 'error_outline' : 'error'"
    >
    </mat-icon>
  }

  <div class="app-desc">
    <h2 class="app-title red">{{ title }}</h2>
    <p>{{ description }}</p>
  </div>
</button>
